// extracted by mini-css-extract-plugin
export var width100 = "S_w d_w";
export var design3Pos = "S_x4 d_0";